import { ApiService } from './api/api'
import { processParams } from '@/utils/params'

export default class ProductCategoryService {
	private apiService

	constructor() {
		this.apiService = new ApiService()
	}

	/**
	 * Get all product categories
	 * @returns Promise
	 */
	getAll(params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products/categories`, { params: processParams(params) })
	}

	/**
	 * Get a product category
	 * @param id String
	 * @param params Record<string, string | string[]
	 * @returns Promise
	 */
	get(id: string, params?: Record<string, string | string[]>): Promise<any> {
		return this.apiService.get(`/products/categories/${id}`, { params: processParams(params) })
	}
}
